const isPHEV = vehicle => {
  const fuelType = vehicle?.fuel;

  return ["PHEV"].includes(fuelType.toUpperCase());
};

export {
  isPHEV
};
